<template>
  <el-form
    :rules="rules"
    size="medium"
    ref="form"
    :model="form"
    label-width="80px"
  >
    <el-form-item
      label="新密码"
      class="w400"
      prop="pwd1"
    >
      <el-input
        class="wp100"
        auto-complete="new-password"
        type="password"
        placeholder="请输入新密码"
        v-model="form.pwd1"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="再次输入"
      class="w400"
      prop="pwd2"
    >
      <el-input
        class="wp100"
        auto-complete="new-password"
        type="password"
        placeholder="请再次输入新密码"
        v-model="form.pwd2"
      ></el-input>
    </el-form-item>

  </el-form>
</template>

<script>
export default {
  data() {
    return {
      ck: false,
      options: [],
      form: {
        pwd1: "",
        pwd2: "",
      },
      rules: {
        pwd1: [{ required: true, message: "请输入新密码", trigger: "blur" }],
        pwd2: [
          { required: true, message: "请再次输入新密码", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    yes(close) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.pwd1 != this.form.pwd2) {
            this.alertWarning("两次密码不一致");
            return;
          }
          this.$api.auth
            .changePwd(this.form.pwd1)
            .then((r) => {
              if (r.Status == 1) {
                this.alert(r.Data);
                close();
              } else {
                this.alertError(r.Data);
              }
            })
            .catch((r) => {});
        } else {
          this.alertError("信息不完整");
        }
      });
    },
  },
};
</script>